import UAParser from 'ua-parser-js'

export const UAparser = new UAParser()

export const isFirefox = () => {
  const UAParserResult = UAparser.getResult()

  return UAParserResult.browser.name === 'Firefox'
}
